export default __webpack_public_path__ + "static/media/euro-bg.db91b24c.jpg";